@if (hasFilters()) {
  <gstar-prime-grid-filter-form
    #filters
    triggerByChanges
    [filters]="headers()"
    [sessionKey]="sessionKey()"
    (queryChange)="filterChange($event)"
    (clearAll)="emitClear()">
    <ng-container start-toolbar-filter>
      <ng-content select="[start-toolbar]" />
    </ng-container>
    <ng-container end-toolbar-filter>
      <ng-content select="[end-toolbar]" />
    </ng-container>
  </gstar-prime-grid-filter-form>
}
<p-table
  [value]="dataSource()"
  [lazy]="!!settings()?.lazy"
  [rowTrackBy]="rowTrackBy"
  (onSort)="sortTable($event)"
  [customSort]="true">
  <ng-template pTemplate="header">
    <tr>
      @if (settings()?.hasCheckbox) {
        <th class="ap-p-spacing-4">
          <ap-checkbox
            #checkbox
            (onChange)="openSelectAllModal()"
            [ngModel]="selectedAll()" />
        </th>
      }
      @if (settings()?.isAccordionEnabled) {
        <th></th>
      }
      @if (hasButtons()) {
        <th>
          {{ 'admin.grid.actionsColumnName' | translate }}
        </th>
      }
      @for (header of headers(); track header.key) {
        @if (header.isVisible !== false) {
          <gstar-prime-grid-header
            [header]="header"
            class="d-table-cell"
            role="cell" />
        }
      }
      @if (settings()?.tooltips) {
        <th>
          {{ settings()?.tooltips?.header }}
        </th>
      }
      @if (settings()?.actionMenu) {
        <th></th>
      }
    </tr>
  </ng-template>
  <ng-template pTemplate="body" let-row let-rowIndex="rowIndex">
    <tr>
      @if (!settings()?.lazy || !isLoading()) {
        @if (settings()?.hasCheckbox) {
          <td>
            <ap-checkbox
              #checkrow
              (onChange)="openSingleModal(row, checkrow)"
              class="ap-table-checkbox-container"
              [(ngModel)]="row.isChecked" />
          </td>
        }
        @if (settings()?.isAccordionEnabled) {
          <td>
            <gstar-prime-grid-accordion-button
              [row]="row"
              [isExpandedByDefault]="
                settings()?.isExpandedByDefault ?? false
              " />
          </td>
        }
        @if (hasButtons()) {
          <gstar-grid-crud-buttons [setting]="settings()" [data]="row.data" />
        }
        @for (header of headers(); track header.label) {
          @if (header.isVisible !== false) {
            <td>
              @if (header.dataType === templateColumnType) {
                <gstar-grid-template-factory [header]="header" [row]="row" />
              } @else {
                <div
                  class="cell-text-force-wrap"
                  [class.cell-text-inline-ellipsis]="
                    header.key === 'explanation'
                  "
                  [gstarPrimeGridRowAccordion]="row.isRowExpanded"
                  [isRowDisabled]="row.isDisabledAccordionButton"
                  [cellKey]="header.key"
                  [cellsToExpand]="settings()?.collapsableRows || []">
                  <ng-template #explanationTooltipTemplate>
                    @let explanationTooltipValue =
                      (row.data && row.data['explanationHtml']) ||
                      (row.data
                        | gridRowIterator: header.key : header.dataType) ||
                      '';

                    @if (isHtmlContent(explanationTooltipValue)) {
                      <div class="explanation-tooltip-content-wrapper">
                        <div
                          class="explanation-tooltip-html-content"
                          [innerHTML]="
                            sanitizeTooltipHtml(explanationTooltipValue)
                              | blankLinks
                              | safe: 'html'
                          "></div>
                        @if (
                          shouldShowExplanationViewMore(explanationTooltipValue)
                        ) {
                          <div class="view-more-tooltip-span">
                            {{ 'admin.grid.viewMore' | translate }} ...
                          </div>
                        }
                      </div>
                    } @else {
                      <div style="white-space: pre-line">
                        {{ explanationTooltipValue }}
                      </div>
                    }
                  </ng-template>
                  <span
                    #cellText
                    ap-tooltip
                    direction="top"
                    [class.cursor-pointer]="isCellClickable(header)"
                    [attr.role]="isCellClickable(header) ? 'button' : null"
                    [attr.tabindex]="isCellClickable(header) ? 0 : null"
                    [tooltipStyleClass]="
                      header.key === 'explanation'
                        ? 'prime-grid-explanation-tooltip'
                        : ''
                    "
                    [tooltipContent]="
                      header.key === 'explanation' && isTextTruncated(cellText)
                        ? explanationTooltipTemplate
                        : null
                    "
                    (click)="onCellClick(header, row.data)"
                    (keydown.enter)="onCellClick(header, row.data)"
                    (keydown.space)="onCellClick(header, row.data)"
                    >{{
                      row.data | gridRowIterator: header.key : header.dataType
                    }}</span
                  >
                </div>
              }
            </td>
          }
        }
        @if (settings()?.tooltips) {
          <td>
            <span
              ap-tooltip
              tooltipId="tooltipDesc"
              ariaDescribedby="tooltipDesc"
              direction="top"
              [tooltipContent]="settings()?.tooltips?.label(row.data)"
              class="ap-font-16 Appkit4-icon"
              [ngClass]="settings()?.tooltips?.icon(row.data)"></span>
          </td>
        }
        @if (settings()?.actionMenu) {
          <gstar-action-menu
            [actionMenu]="settings()?.actionMenu(row.data)"
            [rowData]="row.data" />
        }
      }
    </tr>
  </ng-template>
  <ng-template pTemplate="emptymessage">
    @if (!isLoading()) {
      <tr>
        <td [attr.colspan]="headers().length + this.extraColumnsCount">
          <div class="d-flex justify-content-center align-items-center">
            {{ settings()?.emptyMessage }}
          </div>
        </td>
      </tr>
    } @else {
      @for (_ of skeletonRows(); track $index) {
        <tr>
          <td [attr.colspan]="headers().length + this.extraColumnsCount">
            <p-skeleton width="100%" class="mb-2" height="2rem" />
          </td>
        </tr>
      }
    }
  </ng-template>
  <ng-template pTemplate="sorticon" field="col.field" let-sortOrder>
    <button class="sort-icon-wrapper p-0" type="button">
      @if (sortOrder === 0) {
        <span class="Appkit4-icon icon-sorting-fill sort-table animated"></span>
      } @else {
        <span
          class="Appkit4-icon icon-sorting-ascendant-fill sort-table animated sorted"
          [class.descendant]="sortOrder === -1">
        </span>
      }
    </button>
  </ng-template>
</p-table>
<gstar-grid-footer
  [data]="dataSource()"
  [paginationSetting]="pagination"
  [options]="settings()?.paginationOptions ?? options"
  [extendedPagination]="!!settings()?.extendedPagination"
  (pageChange)="pageChange($event)" />
